<h2 mat-dialog-title>{{ href() ? 'Edit Link' : 'Insert Link' }}</h2>

<mat-dialog-content>
  <label class="link-label" for="mce-link-url">URL</label>
  <input
    id="mce-link-url"
    class="link-input"
    [ngModel]="href()"
    (ngModelChange)="href.set($event)"
    placeholder="https://example.com"
    spellcheck="false"
    autocomplete="off"
    autofocus>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" type="button" (click)="save()" [disabled]="!href().trim()">
    {{ href() ? 'Update' : 'Insert' }}
  </button>
</mat-dialog-actions>
